export default {
  title: 'Archivos adjuntos'
}
